import { ensureSliderNav } from './slider-nav.js'

$(function(){

    var $window = $(window);

    if ($window.width() < 1023) {
        if($(".home-navigate-menu").length > 0){
            var menuPosition = $(".home-navigate-menu ul li").find('a.active').position();
            var leftPos = $('.home-navigate-menu').scrollLeft();
            $(".home-navigate-menu").animate({
                scrollLeft: menuPosition
            }, 800);
        }
    }

    // $('.home-navigate-menu').navpoints({offset:40});

    var $window = $(window);

    if ($window.width() > 1200) {
        $("#nav li").hover(function(){
            $("#nav li .nav-menu").stop(true, true).fadeOut("fast");
            $(this).find(".nav-menu").stop(true, true).fadeIn("normal");
        }, function(){
            $("#nav li .nav-menu").stop(true, true).hide();
        });

    }

    var $window = $(window);

    $window.scroll(function() {
        if ($(document).scrollTop() >= 20) {
            $('html').addClass('scroll');
        } else {
            $('html').removeClass('scroll');
        }
    });

// nette.js içindeki ilgili kısım:
    $(".hero-search-category-icon").click(function (e) {
        e.preventDefault(); // return false yerine bunu kullan
        $(this).toggleClass('hero-search-category-close');
        $(".hero-search-category-list").stop(true , true).slideToggle();
    });

    // $(".search-filter-icon").click(function () {
    //     $('body').toggleClass('nav-opened');
    //     $(this).toggleClass('hero-search-filter-close');
    //     $(".search-filter-box").stop(true , true).slideToggle();
    //     return false;
    // });

    $(".toggle-icon").click(function () {
        $(this).toggleClass('toggle-icon-close');
        $(".toggle-content").stop(true , true).slideToggle();
        return false;
    });

    $('.sticky-nav-tab').navpoints({
        offset:(document.querySelector('.header')?.offsetHeight || 0)
            + (document.querySelector('.hm-detail-actions')?.offsetHeight || 0)
            + (document.querySelector('.listing-fixed-bar')?.offsetHeight || 0) + 12
    });

    $('.fancybox').fancybox();
    new Sticky('.sticky:not(.listing-sidebar-wrap)');



    $(".page-filter-map").click(function () {
        $('body').toggleClass('nav-opened');
        $(this).toggleClass('page-filter-map-close');
        $(".search-layout-map").stop(true , true).slideToggle();

        return false;
    });

});

$(document).ready(function(){
    function hmGetMenuTarget($trigger) {
        var $target = $trigger.parent().children('.menu-dropdown').first();

        if (!$target.length) {
            var targetId = $trigger.data('menu-target');
            if (targetId) {
                $target = $('#' + targetId);
            }
        }

        return $target;
    }

    function hmSyncMenuState() {
        var hasMobileMenuOpen = $('.mobile-nav .menu-trigger.menu-trigger-active').length > 0;
        var hasSmallScreenHeaderMenuOpen = window.innerWidth <= 1023 && $('.header .menu-trigger.menu-trigger-active').length > 0;

        $('body').toggleClass('lockscreen', hasMobileMenuOpen || hasSmallScreenHeaderMenuOpen);
        $('body').toggleClass('hm-mobile-menu-open', hasMobileMenuOpen);

        if (!hasMobileMenuOpen && !hasSmallScreenHeaderMenuOpen) {
            $('html').removeClass('lockscreen hm-mobile-menu-open menu-open nav-opened');
            $('body').removeClass('menu-open nav-opened');
            $('body').css({ top: '', left: '', right: '', width: '' });
        }
    }

    var HM_ACCOUNT_DROPDOWN_CLOSE_SPEED = 160;
    var HM_ACCOUNT_DROPDOWN_OPEN_SPEED = 280;

    function hmHasOpenAccountDropdowns() {
        return $('.header-login-wrap .menu-trigger.menu-trigger-active, .mobile-nav .menu-trigger.menu-trigger-active').length > 0
            || $('.header-login-wrap .menu-dropdown:visible, .mobile-nav .menu-dropdown:visible').length > 0;
    }

    function hmCloseAccountDropdowns($exceptDropdown) {
        var $dropdowns = $('.header-login-wrap .menu-dropdown, .mobile-nav .menu-dropdown');

        if ($exceptDropdown && $exceptDropdown.length) {
            $dropdowns = $dropdowns.not($exceptDropdown);
        }

        $dropdowns.stop(true, true).slideUp(HM_ACCOUNT_DROPDOWN_CLOSE_SPEED).attr('aria-hidden', 'true');
        $dropdowns.each(function(){
            var $wrap = $(this).closest('.header-login-wrap, .mobile-nav-item');
            $wrap.removeClass('active open opened menu-open menu-trigger-active');
            $wrap.find('.menu-trigger, .mobile-nav-icon')
                .removeClass('menu-trigger-active active open opened')
                .attr('aria-expanded', 'false');
        });

        hmSyncMenuState();
    }

    $('.header .menu-trigger, .mobile-nav .menu-trigger').off('click.hmAccountMenu').on('click.hmAccountMenu', function(event){
        event.preventDefault();
        event.stopPropagation();

        var $trigger = $(this);
        var $target = hmGetMenuTarget($trigger);

        if (!$target.length) return false;

        var isOpen = $target.is(':visible');

        hmCloseAccountDropdowns($target);

        if (isOpen) {
            $target.stop(true, true).slideUp(HM_ACCOUNT_DROPDOWN_CLOSE_SPEED).attr('aria-hidden', 'true');
            $trigger.removeClass('menu-trigger-active active open opened').attr('aria-expanded', 'false');
        } else {
            $target.stop(true, true).slideDown(HM_ACCOUNT_DROPDOWN_OPEN_SPEED).attr('aria-hidden', 'false');
            $trigger.addClass('menu-trigger-active').attr('aria-expanded', 'true');
        }

        hmSyncMenuState();
        return false;
    });

    $(document).off('click.hmAccountMenuOutside').on('click.hmAccountMenuOutside', function(event){
        var $target = $(event.target);

        if ($target.closest('.header-login-wrap, .hm-mobile-menu-dropdown, .mobile-nav .menu-trigger, .fancybox__container, .fancybox-container, .my-fancy').length) {
            return;
        }

        if (!hmHasOpenAccountDropdowns()) {
            return;
        }

        hmCloseAccountDropdowns();
    });

    $(document).off('click.hmMobileAccountClose').on('click.hmMobileAccountClose', '[data-hm-mobile-menu-close]', function(event){
        event.preventDefault();
        event.stopPropagation();
        hmCloseAccountDropdowns();
        return false;
    });

    $(document).off('keydown.hmAccountMenu').on('keydown.hmAccountMenu', function(event){
        if (event.key === 'Escape') {
            hmCloseAccountDropdowns();
        }
    });
});

$(document).ready(function(){

    $('.slider-hero').slick({
        arrows:false,
        dots:true,
        pauseOnHover:true,
        speed:750,
        autoplay:false,
        responsive: [
            {
                breakpoint:1023,
                settings: {
                    arrows:false
                }
            }
        ]
    });

    $('.slider-list').each(function () {
        $(this).slick({
            dots:false,
            pauseOnHover:true,
            speed:750,
            autoplay:false,
            swipeToSlide:true,
            slidesToShow:4,
            appendArrows: ensureSliderNav(this),
            responsive: [
                {
                    breakpoint:1180,
                    settings: {
                        slidesToShow:3
                    }
                },
                {
                    breakpoint:760,
                    settings: {
                        slidesToShow:2
                    }
                },
                {
                    breakpoint:550,
                    settings: {
                        slidesToShow:2
                    }
                }
            ]
        });
    });

    const $sli = $('.slider-sli').not('[data-vue-slider="1"]');

    $sli.on('init reInit afterChange', function(event, slick, currentSlide){
        const i = (currentSlide || 0) + 1;

        // ✅ sadece kendi wrap'inin counter'ını güncelle (global değil)
        $(this)
            .closest('.slider-sli-wrap')
            .find('.slider-counter')
            .text(i + '/' + slick.slideCount);
    });

    // ✅ double init olmasın
    $sli.not('.slick-initialized').slick({
        arrows:true,
        dots:false,
        speed:350,
        autoplay:false
    });

    window.initAgencySlider = function(targetElement) {
        // Eğer bir hedef element gelirse sadece onu, gelmezse tümünü (ilk yükleme için) hedefle
        const $target = targetElement ? $(targetElement) : $('.slider-real-estates');

        $target.each(function() {
            const $this = $(this);

            // Sadece henüz başlatılmamış olanları başlat
            if (!$this.hasClass('slick-initialized')) {
                $this.slick({
                    dots: false,
                    pauseOnHover: true,
                    speed: 750,
                    autoplay: false,
                    swipeToSlide: true,
                    slidesToShow: 4,
                    responsive: [
                        { breakpoint: 1680, settings: { slidesToShow: 3 } },
                        { breakpoint: 1541, settings: { slidesToShow: 4 } },
                        { breakpoint: 1380, settings: { slidesToShow: 3 } },
                        { breakpoint: 1210, settings: { slidesToShow: 4 } },
                        { breakpoint: 1020, settings: { slidesToShow: 3 } },
                        { breakpoint: 760, settings: { slidesToShow: 2 } }
                    ]
                });
            }
        });
    };


// Sayfa ilk açıldığında çalıştır (Eğer statik acente varsa)
    $(document).ready(function(){
        if ($('.slider-real-estates').length > 0 && !$('.slider-real-estates').hasClass('vue-managed')) {
            window.initAgencySlider();
        }
    });

});

$(document).ready(function(){
    $('div#nav ul li.nav-multi > a').click(function(event){

        if ($(window).width() < 1023) {
            event.preventDefault();

            $(this).parent().parent().children('li').children('.nav-menu').not($(this).parent().children(".nav-menu")).slideUp();
            $(this).parent().children('.nav-menu').stop(true , true).slideToggle();
            return false;
        }
    })
});

$(document).ready(function() {
    function close_accordion_section() {
        $('.accordion .accordion-section-title').removeClass('active');
        $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');

        if($(e.target).is('.active')) {
            close_accordion_section();
        }else {
            close_accordion_section();

            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
        }

        e.preventDefault();
    });
});

// Header ve işlem çubukları kaydırma yönünden bağımsız görünür kalır.

document.addEventListener("DOMContentLoaded", () => {
    const toggles = document.querySelectorAll(".filter-toggle-icon");

    toggles.forEach(toggle => {
        toggle.addEventListener("click", (e) => {
            e.stopPropagation();

            const currentBox = toggle.closest(".filter-toggle-wrap").querySelector(".filter-toggle-box");
            const isActive = toggle.classList.contains("toggle-active");

            // önce tümünü kapat
            toggles.forEach(t => {
                t.classList.remove("toggle-active");
                const box = t.closest(".filter-toggle-wrap").querySelector(".filter-toggle-box");
                box.style.display = "none";
            });

            // eğer tıklanan zaten aktif değilse aç
            if (!isActive) {
                toggle.classList.add("toggle-active");
                currentBox.style.display = "block";
            }
        });
    });

    // dışarıya tıklanınca kapat
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".filter-toggle-wrap")) {
            toggles.forEach(t => {
                t.classList.remove("toggle-active");
                const box = t.closest(".filter-toggle-wrap").querySelector(".filter-toggle-box");
                box.style.display = "none";
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const closeBtn = document.querySelector(".search-filter-close");
    const filterBox = document.querySelector(".search-filter-box");

    if (closeBtn && filterBox) {
        closeBtn.addEventListener("click", function () {
            filterBox.style.display = "none";
            document.body.classList.remove("nav-opened");
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const tabLinks = document.querySelectorAll(".tab-ajax a");
    const tabContents = document.querySelectorAll(".real-estate-content");

    tabLinks.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // aktif class'ı kaldır
            tabLinks.forEach(l => l.classList.remove("active"));
            this.classList.add("active");

            // içerikleri gizle
            tabContents.forEach(content => content.style.display = "none");

            // tıklanan linkin hedefini bul
            const target = this.getAttribute("data-tab-ajax").replace("tab-ajax", "tab-content");
            const activeContent = document.querySelector(`[data-tab-content="${target}"]`);
            if (activeContent) activeContent.style.display = "block";
        });
    });

    // Sayfa yüklendiğinde ilk tab'ı göster
    tabContents.forEach((c, i) => c.style.display = i === 0 ? "block" : "none");
});

window.initFloorplanSlider = function(targetElement) {
    let $target;

    if (targetElement) {
        const $root = $(targetElement);
        $target = $root.hasClass('floorplan-slider')
            ? $root
            : $root.find('.floorplan-slider');
    } else {
        $target = $('.floorplan-slider');
    }

    $target.each(function() {
        const $slider = $(this);

        if ($slider.data('fpReady') === 1) {
            const updater = $slider.data('fpUpdate');
            if (typeof updater === 'function') updater();
            return;
        }

        const $scroll = $slider.find('.floorplan-slider-scroll');
        const $left   = $slider.find('.floorplan-slider-arrow.left');
        const $right  = $slider.find('.floorplan-slider-arrow.right');

        if (!$scroll.length || !$left.length || !$right.length) return;

        function updateArrows() {
            const el = $scroll[0];
            const scrollWidth = el.scrollWidth;
            const clientWidth = el.clientWidth;
            const scrollLeft  = el.scrollLeft;

            if (scrollWidth > clientWidth + 5) {
                $left.show();
                $right.show();
            } else {
                $left.hide();
                $right.hide();
            }

            $left.css('opacity', scrollLeft > 5 ? '1' : '0');
            $right.css(
                'opacity',
                (scrollLeft + clientWidth) < (scrollWidth - 5) ? '1' : '0'
            );
        }

        function scrollSlider(direction) {
            const el = $scroll[0];
            const step = window.innerWidth <= 540 ? el.clientWidth : 330;

            el.scrollTo({
                left: el.scrollLeft + (direction === 'left' ? -step : step),
                behavior: 'smooth'
            });

            setTimeout(updateArrows, 220);
        }

        $left.off('.floorplan').on('click.floorplan', function(e) {
            e.preventDefault();
            e.stopPropagation();
            scrollSlider('left');
        });

        $right.off('.floorplan').on('click.floorplan', function(e) {
            e.preventDefault();
            e.stopPropagation();
            scrollSlider('right');
        });

        $scroll.off('.floorplan').on('scroll.floorplan', updateArrows);

        if (window.ResizeObserver) {
            const ro = new ResizeObserver(function() {
                updateArrows();
            });
            ro.observe($scroll[0]);
            $slider.data('fpResizeObserver', ro);
        }

        $slider.data('fpReady', 1);
        $slider.data('fpUpdate', updateArrows);

        requestAnimationFrame(function() {
            setTimeout(updateArrows, 0);
        });
    });
};

$(document).ready(function(){
    if ($('.floorplan-slider').length > 0) {
        window.initFloorplanSlider(document);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.home-accordion-item');

    items.forEach(item => {
        item.addEventListener('click', function(e) {
            // 1. Tüm sekmelerden aktifliği kaldır
            items.forEach(i => i.classList.remove('home-active'));

            // 2. Tıklanan sekmeye aktiflik ekle
            this.classList.add('home-active');
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const wraps = document.querySelectorAll('.highlights-wrap');

    wraps.forEach(wrap => {
        // Artık hesaplamaları wrapper üzerinden yapıyoruz
        const wrappers = wrap.querySelectorAll('.highlight-item-wrapper');
        const navLinks = wrap.querySelectorAll('.home-navigate-menu a');

        if (wrappers.length === 0 || navLinks.length === 0) return;

        // 1. Sol Menüye Tıklanınca Pürüzsüz Kayma
        navLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const targetId = this.getAttribute('href').replace('#', '');
                const targetWrapper = document.getElementById(targetId);

                if (targetWrapper) {
                    // targetWrapper statik bir element olduğu için offset %100 doğru gelir.
                    // Sayfa takılması veya yanlış yere gitmesi tarihe karıştı.
                    const offsetPosition = targetWrapper.getBoundingClientRect().top + window.scrollY - 80;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        // 2. Takılmayan (Jank-Free) Odak Tetikleyicisi
        const observerOptions = {
            root: null,
            // Header hizasını göz önüne alarak kesişim alanını daraltıyoruz
            rootMargin: '-100px 0px -40% 0px',
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Sınıfları temizle
                    navLinks.forEach(link => link.classList.remove('active'));
                    wrap.querySelectorAll('.highlight-item').forEach(i => i.classList.remove('is-active'));

                    // Ekranda olan Wrapper'ın içindeki .highlight-item'ı aktif et (animasyonlar için)
                    const innerItem = entry.target.querySelector('.highlight-item');
                    if(innerItem) innerItem.classList.add('is-active');

                    // Sol menüyü aktif et
                    const activeId = entry.target.getAttribute('id');
                    const activeLink = wrap.querySelector(`.home-navigate-menu a[href="#${activeId}"]`);
                    if (activeLink) activeLink.classList.add('active');
                }
            });
        }, observerOptions);

        // Observer artık Sticky kartları değil, onları taşıyan statik Wrapper'ları izliyor.
        wrappers.forEach(wrapper => observer.observe(wrapper));

        // İlk yüklemede aktifliği ver
        if(wrappers.length > 0) {
            const firstInner = wrappers[0].querySelector('.highlight-item');
            if(firstInner) firstInner.classList.add('is-active');
            navLinks[0].classList.add('active');
        }
    });
});
